<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="400px"
        title=""
    >
        <div class="wrap">
            <div v-show="step === 1 && !!hisSign" class="top">
                <span>历史签名：</span>
                <span style="color: #0a8dff;cursor: pointer" @click="reSign()">重新签字</span>
            </div>
            <div class="re-top" v-show="step === 2 && !!hisSign">
                <span style="color: #0a8dff;cursor: pointer" @click="preSign()">使用上次签名</span>
            </div>
            <div class="his-sign" v-show="step===1 && !!hisSign">
                <img :src="hisSign" alt="">
            </div>
            <div class="sign" v-show="step===2">
                <img :src="qrcode" alt="" v-if="qrcode">
                <span>请使用微信扫码，进行{{type_name}}签字确认</span>
            </div>
        </div>
        <div class="btn-wrap">
            <el-button class="btn cancel" size="small" v-if="!isForceSign" @click="jump()">跳过</el-button>
            <el-button class="btn" type="primary" size="small" @click="checkSignStatus()">确认签字</el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      dialogVisible: false,
      qrcode: '',
      type: '',
      type_name: '',
      isForceSign: false,
      step: 1,
      hisSign: '',
      check: false,
      skip_sign: false,
      use_latest_sign: false
    }
  },
  methods: {
    /**
     * 显示弹窗
     * params 传入的参数
     */
    show(params) {
      console.log(params)
      this.dialogVisible = true;
      this.qrcode = params.qrcode;
      this.hisSign = params.hisSign;
      this.type = params.type;
      this.step = params.step;
      this.isForceSign = params.isForceSign;
      this.check = false;
      this.skip_sign = false;
      this.use_latest_sign = false;
      if (this.type === 'wjo') {
        this.type_name = '入库';
      } else if (this.type === 'rjo') {
          this.type_name = '退货';
      }
    },
    close() {
      this.dialogVisible = false;
    },
    jump() {
        this.skip_sign = true
        this.$emit('afterSign', this.check, this.skip_sign, this.use_latest_sign)
    },
    checkSignStatus() {
        // 如果是第二步，判断是否当前签字状态
        if (this.step === 2) {
            this.check = true
            this.$emit('afterSign', this.check, this.skip_sign, this.use_latest_sign)
        } else {
            this.use_latest_sign = true
            this.$emit('afterSign', this.check, this.skip_sign, this.use_latest_sign)
        }
    },
    reSign() {
      this.step = 2;
    },
    preSign() {
      this.step = 1;
    }
  }
}
</script>

<style scoped lang="less">
.wrap{
    padding: 20px;
    .top{
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
    }
    .re-top{
        text-align: right;
        margin-bottom: 16px;
    }
    .his-sign{
        background: rgba(242, 242, 242, 1);
        height: 200px;
        text-align: center;
        img{
            height: 200px;
        }
    }
    .sign{
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
            width: 160px;
            height: 160px;
        }
        span{
            color: #999999;
            margin-top: 20px;
        }
    }
}
.btn-wrap{
    margin-top: 20px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    .cancel{
        margin-right: 24px;
    }
}
</style>
